export const omitUndefined = <TObject extends object>(obj: TObject): TObject =>
  Object.fromEntries(
    Object.entries(obj).filter(([, value]) => value !== undefined)
  ) as TObject;
